<template>
  <div>
    <v-container>
      <div class="text-xs-right">
        <span>
          <v-btn
            :loading="exportloading"
            @click="exportData"
            outline
            color="grey"
            class="ma-0 mb-0"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </span>
      </div>
      <v-layout row wrap>
        <v-flex xs4 class="pr-1">
          <div>ชื่อโครงการ</div>
          <multiselect
            v-model="filter.project"
            :options="projectOptions"
            :allow-empty="false"
            :searchable="false"
            @input="getRunner"
            selectLabel
            placeholder="เลือกโครงการ"
            selectedLabel
            deselect-label
          ></multiselect>
        </v-flex>
        <v-flex xs4>
          <div>สถานะ</div>
          <multiselect
            v-model="filter.status"
            :options="statusOptions"
            :allow-empty="false"
            :searchable="false"
            @input="getRunner"
            selectLabel
            placeholder="เลือกโครงการ"
            selectedLabel
            deselect-label
          ></multiselect>
        </v-flex>
      </v-layout>
      <div>
        <v-pagination
          :total-visible="15"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>

        <!-- <Pagination :limit="10" :total="total" @onChange="onChangePage"> -->
        <v-data-table
          expand
          :pagination.sync="pagination"
          hide-actions
          :loading="loading"
          :headers="headers"
          :items="data"
          class="elevation-1 scgallrenttable"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">{{ props.item.project_name }}</td>
              <td class="text-xs-center">{{ props.item.ebib }}</td>
              <td
                class="text-xs-center"
                :style="{ color: getStatus(props.item.status).color, fontWeight: 600 }"
              >
                {{ getStatus(props.item.status).label }}
              </td>
              <td class="text-xs-center" style="white-space: nowrap">
                {{ props.item.memberinfo.first_name + ' ' + props.item.memberinfo.last_name }}
              </td>
              <td class="text-xs-center">{{ props.item.memberinfo.email }}</td>
              <td class="text-xs-center">{{ props.item.memberinfo.phoneno }}</td>

              <td class="text-xs-center">{{ props.item.orderaddress }}</td>
              <td class="text-xs-center">
                {{ props.item.registertimestamp | DateFormat('DD/MM/YYYY') }}
              </td>
            </tr>
          </template>
        </v-data-table>
        <!-- </Pagination> -->
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import Pagination from '@/components/elements/Pagination2.vue'
import moment from 'moment'
import XLSX from 'xlsx'
export default {
  components: {
    Multiselect,
    Pagination
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    },
    projectOptions() {
      return this.projects
    }
  },
  data() {
    return {
      pagination: { sortBy: 'registertimestamp', descending: true, rowsPerPage: 10 },
      exportloading: false,
      total: 0,
      data: [],
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      loading: false,
      headers: [
        { text: 'โครงการ', value: 'project_name', align: 'left', width: '1%' },
        { text: 'E-BIB No', value: 'ebib', align: 'left', width: '1%' },
        { text: 'สถานะ', value: 'status', align: 'left', width: '1%' },
        { text: 'ชื่อ', value: 'first_name', align: 'left', width: '1%' },
        { text: 'อีเมล', value: 'email', align: 'left', width: '1%' },
        { text: 'เบอร์โทร', value: 'phoneno', align: 'left', width: '1%' },
        { text: 'ที่อยู่', value: 'address', align: 'left', width: '3%' },
        { text: 'วันที่สมัคร', value: 'registertimestamp', align: 'left', width: '1%' }
      ],
      sortBy: 'registertimestamp',
      filter: {
        project: '',
        status: 'All'
      },

      projects: [],
      statusOptions: ['All', 'Success', 'Not Success']
    }
  },
  async mounted() {
    await this.getProject()
    await this.getRunner()
  },
  methods: {
    async exportData() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filename = 'Participants'

      var json = []

      vm.exportloading = true
      var response = await this.getRunner('export')

      if (response) {
        var data = response
      }

      json = data.map((el) => {
        return {
          โครงการ: el.project_name ? el.project_name : '-',
          'E-bib No': el.ebib ? el.ebib : '-',
          สถานะ: el.status ? this.getStatus(el.status).label : '-',
          ชื่อ: el.memberinfo.first_name
            ? el.memberinfo.first_name + ' ' + el.memberinfo.last_name
            : '-',
          อีเมล: el.memberinfo.email ? el.memberinfo.email : '-',
          เบอร์โทร: el.memberinfo.phoneno ? el.memberinfo.phoneno : '-',
          ที่อยู่: el.memberinfo.address ? this.getFullAddress(el.memberinfo) : '-',
          วันที่สมัคร: el.registertimestamp
            ? moment(el.registertimestamp).format('DD/MM/YYYY')
            : '-'
        }
      })

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
      vm.exportloading = false
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getRunner()
      }
    },
    getStatus(status) {
      if (status) return { label: 'วิ่งสำเร็จ', color: '#09b109' }
      else return { label: 'วิ่งไม่สำเร็จ', color: 'orange' }
    },
    getFullAddress(item) {
      return `${item.address} จังหวัด${item.province} เขต${item.district} แขวง${item.sub_district} ${item.postcode}`
    },

    getRunner(option) {
      var data = {
        pageid: this.selectedBot.pageid, // required

        project_name: this.filter.project, // required
        status: this.filter.status == 'All' ? '' : this.filter.status // Success, Not Success
      }
      if (option != 'export') {
        Object.assign(data, { limit: this.limit, offset: this.offset })
      }
      return new Promise((resolve) => {
        this.loading = true
        api.getrunkanparticipantsdashboard(data, (err, response) => {
          this.loading = false

          this.total = parseInt(response.total)
          this.$forceUpdate()
          var result = response.data.map((el) => {
            var memberinfo = {}
            if (el.memberinfo) {
              memberinfo = JSON.parse(el.memberinfo)
            }
            return { ...el, memberinfo }
          })
          if (option != 'export') {
            this.data = result
          }
          resolve(result)
        })
      })
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    getProject() {
      return new Promise((resolve) => {
        api.getrunkanprojects({ pageid: this.selectedBot.pageid }, (err, response) => {
          if (response.responsecode == 200) {
            this.projects = response.data.map((el) => el.project_name)
            this.filter.project = this.projects[0]
          }
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/runkan/Participants.vue